import { Upload, UploadProps } from 'antd';
import { FC } from 'react';

const UploadDragger: FC<UploadProps> = ({ children, ...props }) => {
  return <Upload.Dragger {...props}>{children}</Upload.Dragger>;
};

export default UploadDragger;
